import React, { useState, useEffect, useContext } from 'react';
import AppContext from '../../context';
import './index.scss';

export default function Footer() {
    const { version } = useContext(AppContext);

    const getYear = () => {
        return new Date().getFullYear();
    };

    return (
        <div className="app-footer">
            <div className="app-footer-body max-width">
                <div className="friend">
                    <span className="title">友情感谢</span>
                    <a className="title-padding" target="_blank" href="https://gh.waimai.sankuai.com/">灰度小助手</a>
                    <a className="title-padding" target="_blank" href="https://wmroo.sankuai.com/">积木UI一致性</a>
                </div>
                <div className="contact">
                    <div className="title">联系我们</div>
                    <img src="https://s3plus.meituan.net/v1/mss_5a4c90a1d729431289d2c9ab38853394/waimai-debug-kit/1616921717629-image.png" alt="" />
                </div>
            </div>
        </div>
    );
}
